// Other drag and drop libraries:
// https://github.com/valor-software/ng2-dragula
// https://kutlugsahin.github.io/ngx-smooth-dnd/
// https://angular-dnd-survey-creator.netlify.com/editor
// https://github.com/angular/components/issues/14273

// A more complex method to deep clone an object
// https://stackoverflow.com/questions/28150967/typescript-cloning-object/28152032#28152032
import { inject, InjectionToken } from '@angular/core';
import { AccountGroup } from '@galaxy/account-group';
import { Sender, SenderType } from '@vendasta/email';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * A quick and dirty way to deep copy an object.\
 * *Warning*: This will convert date types into strings
 * @param input - the object to duplicate.
 */
export function jsonCopy(input: object): object {
  return JSON.parse(JSON.stringify(input));
}

export const SENDER_INJECTION_TOKEN: InjectionToken<Observable<Sender>> = new InjectionToken(
  'com.vendasta.email_builder.sender',
);

export function buildSenderData(): Observable<Sender> {
  const partnerID$ = inject('PARTNER_ID' as any, { optional: true }) as Observable<string>;
  const accountGroup$ = inject('com.vendasta.bcc.account_group' as any, {
    optional: true,
  }) as Observable<AccountGroup>;
  const accountGroupID$ = inject('ACCOUNT_GROUP_ID' as any, { optional: true }) as Observable<string>;

  if (accountGroup$) {
    return accountGroup$.pipe(
      map((agid) => {
        const sender = { type: SenderType.SENDER_TYPE_BUSINESS, id: agid.accountGroupId } as Sender;
        return sender;
      }),
    );
  } else if (accountGroupID$) {
    return accountGroupID$.pipe(
      map((agid) => {
        const sender = { type: SenderType.SENDER_TYPE_BUSINESS, id: agid } as Sender;
        return sender;
      }),
    );
  } else if (partnerID$) {
    return partnerID$.pipe(
      map((pid) => {
        const sender = { type: SenderType.SENDER_TYPE_PARTNER, id: pid } as Sender;
        return sender;
      }),
    );
  }

  throw new Error('Expected one of partner ID or account group');
}
